import { Contact } from '@rtls/core/models/human/contact.model';
import { chance, nullable, randomName } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const contactFactory = Factory.makeFactory<Contact>({
	email: Factory.each(() => chance.email()),
	fullName: Factory.each(() => randomName()),
	phone: Factory.each(() => nullable(chance.phone())),
});
